<script>
	// Stores 
	import { 
		textWhatsappLocacao,
		linkWhatsappLocacao
	 } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<div class="box-itens-icon">
		<div class="item">
			<div class="icone">
				<i class="fas fa-user fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Locatário Pessoa Física</h3>
				<ul class="list-cycle">
					<li>Cópia do CPF + RG ou CNH (locatário e esposa)</li>
					<li>Comprovante de domicílio;</li>
					<li>Negativa de protestos na cidade de domicílio (locatário e esposa)</li>
					<li>Comprovante de renda ou declaração do imposto de renda (locatário e esposa)</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-tie fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Locatário Pessoa Jurídica</h3>
				<ul class="list-cycle">
					<li>Cópia do contrato social e última alteração (quando existir)</li>
					<li>Cópia do cartão CNPJ</li>
					<li>Negativa de protesto na cidade da sede da empresa</li>
					<li>Cópia RG + CPF ou CNH dos sócios que assinam pela empresa</li>
					<li>Comprovante de residência dos sócios que assinam pela empresa</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-shield-check fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Seguro Fiança</h3>
				<ul class="list-cycle">
					<li>Cópia do documento de identidade e CPF</li>
					<li>Cópia dos três últimos comprovantes de renda e cópia da CTPS (carteira de trabalho), em caso de autônomo apresentar declaração de IR</li>
					<li>Caso seja casado torna-se necessário encaminhar cópias da mesma documentação do cônjuge e também cópia da certidão de casamento</li>
					<li>Cópia de comprovante de residência</li>
				</ul>
			</div>
		</div>
	</div>
	<hr>
	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<hr>
	<div class="button text-center">        
		<a href="/garantias-locaticias" use:link replace title="" class="btn btn-secondary">
			CONFIRA AS GARANTIAS LOCATÍCIAS <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>
	<br />

</div>